import React from 'react';
import { useBiClickLogger } from './hooks/useBiClickLogger';
import { BiLoggerContextProvider } from './BiLogger.context';
export var BiClickLogger = function (_a) {
    var eventData = _a.eventData, children = _a.children;
    var setTrackingRef = useBiClickLogger(eventData).setTrackingRef;
    return (React.createElement(BiLoggerContextProvider, { value: { setTrackingRef: setTrackingRef } }, children));
};
BiClickLogger.displayName = 'BiClickLogger';
export default BiClickLogger;
//# sourceMappingURL=BiClickClogger.js.map